import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
// import { Image } from '@bd/bdcore-utilities';
import YoutubeThumbnail from '@bd/bdui-youtubethumbnail';
import { get } from 'lodash';
import AccordionToggle from '../../components/AccordionToggle';
import VideoModal from '../../components/VideoModal';


const styles = css`
  @media (min-width: 992px) {
    margin-bottom: 130px;
  }
  .CommunityVideo_videoWrapper {
  position: relative;
  .CommunityVideo_videoIcon {
    position: absolute;
    left: 50%;
    top: 45%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%)
  }
}
`;

function CommunityVideos({ community }) {
  return (
    <div className={styles}>
      <AccordionToggle
        openOnId="directions"
        button={({ contentVisible }) => (
          <div className="">
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Video Gallery</h3>
          </div>
        )}
      >
        <div className="container">
          <div className="row justify-content-center">
            {
                get(community, 'custom_videos', []).map(video => (
                  <div key={video._id} className="col-lg-6">
                    <div className="CommunityVideo_videoWrapper">
                      <h6 className="text-center my-3">{get(video, 'video_title')}</h6>
                      <VideoModal video={video.video} className="position-relative">
                        <YoutubeThumbnail video={get(video, 'video')} />
                        <img
                          className="CommunityVideo_videoIcon"
                          src="/images/icons/play-video-icon.svg"
                          alt="Play Video"
                        />
                      </VideoModal>
                    </div>
                  </div>
                ))
              }
          </div>
        </div>
      </AccordionToggle>
    </div>
  );
}

CommunityVideos.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityVideos;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityVideos.js